import { Button, Modal } from '@shared/widgets';
import ErrorIcon from '@assets/images/auth/auth_error_ico.svg';

interface IErrorRecoveryModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const ErrorRecoveryModal = (props: IErrorRecoveryModalProps) => {
  return (
    <Modal isOpen={props.isOpen} onClose={props.onClose}>
      <div className='mx-auto max-w-[430px] text-center max-md:text-[#4c4c4c80]'>
        <ErrorIcon className='mx-auto mb-4 hidden max-md:block' />
        <h2 className='mb-12 text-center font-[Prata] text-[28px] font-medium text-[#0f0f11] max-md:mb-6 max-md:text-lg'>
          Your details do not match
        </h2>
        <p>The information provided does not match the details in our system. Please contact customer services for assistance.</p>
        <div className='mt-4 mb-8 max-md:mx-6 max-md:mt-4 max-md:rounded-lg max-md:bg-[#d7c29a1a] max-md:p-2'>
          <p className='text-[#000]'>24-hour phone support:</p>
          <p className='text-[#000]'>+44-203-151-7000 / +800-800-00-700</p>
        </div>
        <Button className='mx-auto w-[159px] max-md:w-full' onClick={props.onClose}>
          Ok
        </Button>
      </div>
    </Modal>
  );
};
